// modules
import { addModal } from 'weblite-web-modal-viewer'
import { PrivacyType } from '@weblite/ts-action/user-policy'
// component
import { DeleteExceptionUserMenu } from './delete-exception-user-menu'

const COMPONENT_ID = 'deleteExceptionUserMenu'

interface Prop {
  userId: string
  privacyType: PrivacyType
}

export const showDeleteExceptionUserMenu = (
  props: Prop,
  preventBackClick = false,
) => addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: DeleteExceptionUserMenu },
}
